import script from "./EditableSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./EditableSheet.vue?vue&type=script&setup=true&lang=js"

import "./EditableSheet.vue?vue&type=style&index=0&id=3ffbca3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ffbca3b"]])

export default __exports__